import { api } from '@/api/client';

export interface KoppelVerkoopsorderResult {
  targetProjectId: number;
  movedTaskCount: number;
  warnings: string[];
}

export async function koppelVerkoopsorder(
  projectId: number,
  targetProjectId: number,
): Promise<KoppelVerkoopsorderResult> {
  return api<KoppelVerkoopsorderResult>(`/api/projects/${projectId}/koppel-verkoopsorder`, {
    method: 'POST',
    body: JSON.stringify({ targetProjectId }),
  });
}
